import InfiniteScroll from "react-infinite-scroll-component";
import ScheduledOrders from "../ScheduledOrders";

const Scheduled = ({
  setModal,
  orders,
  total,
  hasMore,
  fetchMoreData,
  fetchData,
}) => {
  return (
    <>
      <button
        type="button"
        data-bs-toggle="offcanvas"
        data-bs-target="#scheduledOrderCanvas"
        className="btn btn-success-light btn-wave waves-effect waves-light w-100 text-nowrap"
      >
        Scheduled
        <span className="ms-2 badge bg-success">{total ?? 0}</span>
      </button>
      <div
        className="offcanvas offcanvas-end"
        tabIndex="-1"
        id="scheduledOrderCanvas"
        aria-labelledby="scheduledOrderLabel1"
      >
        <div className="offcanvas-header d-flex border-bottom border-block-end-dashed">
          <div className="flex-grow-1">
            <div className="d-flex justify-content-between align-items-center px-3 py-2 bg-success-transparent border border-warning border-opacity-25 rounded">
              <span className="d-block fw-medium fs-15">Scheduled</span>
              <div>
                <span className="badge badge-task bg-success">
                  {total ?? 0}
                </span>
              </div>
            </div>
          </div>
          <button
            type="button"
            className="btn-close px-3"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          ></button>
        </div>
        <div className="offcanvas-body">
          <div className="row">
            <div className="col-md-12">
              <div>
                <InfiniteScroll
                  dataLength={orders.length}
                  next={fetchMoreData}
                  hasMore={hasMore}
                  scrollableTarget="scheduled-scroll"
                  loader={
                    <div className="text-center my-3">
                      <div className="spinner-border" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  }
                >
                  <ScheduledOrders
                    orders={orders}
                    setModal={setModal}
                    onReRender={fetchData}
                  />
                  {orders?.length === 0 && (
                    <div className="text-center my-5">
                      <img
                        className="mx-auto w-50 my-5"
                        src={`${process.env.REACT_APP_PUBLIC_URL}assets/images/media/backgrounds/no-content.png`}
                        alt="no-content"
                      />
                    </div>
                  )}
                </InfiniteScroll>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Scheduled;
